import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { useContext, useEffect, useState } from "react";
import { Context } from "contexts/contextState";
import FormField from "components/layouts/applications/wizard/components/FormField";
import { UploadThumbnailModal } from "../components/UploadThumbnailModal";
import { DeleteThumbnailModal } from "../components/DeleteThumbnailModal";
import { handleFormData } from "services/HandleService";

export function CourseThumbnail(props) {
  const { context } = useContext(Context);
  const [thumbnail, setThumbnail] = useState("");
  const [deleteThumbnailModal, setDeleteThumbnailModal] = useState();
  const [updateThumbnailModal, setUpdateThumbnailModal] = useState();

  useEffect(() => {
    if (props.course && !thumbnail) {
      context.fileStorageRepository.findFileStorageById(props.course.thumbnailReference?.id).then(response => {
        setThumbnail(response?.fileUrl || "");
      });
    }
  }, [props.course]);

  return (
    <Card sx={{ height: "100%" }}>
      <DeleteThumbnailModal course={props.course} open={Boolean(deleteThumbnailModal)} onClose={() => setDeleteThumbnailModal(void 0)} />
      <UploadThumbnailModal course={props.course} open={Boolean(updateThumbnailModal)} onClose={() => setUpdateThumbnailModal(void 0)} />
      <SoftBox p={3}>
        <SoftTypography variant="h5" fontWeight="bold">
          Thumbnail
        </SoftTypography>
        <SoftBox component="img" src={thumbnail} borderRadius="lg" shadow="lg" width="100%" my={3} />
        <SoftBox display="flex" justifyContent="space-between">
          <SoftButton variant="outlined" color="dark" size="small"
            onClick={() => setDeleteThumbnailModal(true)}
            disabled={!(context.permission?.root || context.permission?.course?.update)}
          >
            remove
          </SoftButton>
          <SoftButton variant="gradient" color="info" size="small"
            onClick={() => setUpdateThumbnailModal(true)}
            disabled={!(context.permission?.root || context.permission?.course?.update)}
          >
            update
          </SoftButton>
        </SoftBox>
      </SoftBox>
      <SoftBox p={3}>
        <SoftTypography variant="h5" fontWeight="bold">
          Presentation Video
        </SoftTypography>
        <SoftBox item xs={12}>
          <FormField type="text" value={props.course.youtubeLink || ""} name="youtubeLink" label="youtube link" placeholder="https://..." onChange={(event) => handleFormData(event, props.setCourse)} />
        </SoftBox>
      </SoftBox>
    </Card>
  )
}

CourseThumbnail.propTypes = {
  course: PropTypes.object.isRequired,
  setCourse: PropTypes.func.isRequired
}